module.exports = __webpack_public_path__ + "media/sub2-5-1.47fc17ef.mp4";